module.exports = __webpack_public_path__ + "assets/img/jiaoshiduan.12067052.png";